import { useMatches, NavLink, useLocation, matchPath } from 'react-router-dom';
import NRBreadcrumbsStyles from './NRBreadcrumbs.styles';
import makeStyles from '@mui/styles/makeStyles';
import NRSummaryActions from '../NRSummaryActions/NRSummaryActions';
import Typography from '@mui/material/Typography';
import React, { useContext } from 'react';
import NRShowAssetStatus from '../NRShowAssetStatus/NRShowAssetStatus';
import Box from '@mui/material/Box';
import NRViewActivityFeedButton from '../NRViewActivityFeed/NRViewActivityFeedButton';
import NRRiseAIChatButton from '../NRRiseAiChat/NRRiseAiChatButton';
import { useFlag } from '@openfeature/react-sdk';
import { OrgLevelSettingsContext } from '../../pages/NRSettings/NRGeneralSettings/NROrgLevelSettingsContextWrapper';

const useStyles = makeStyles(NRBreadcrumbsStyles);
const groupIdRegex = /^\/groups\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const SHOW_ACTIONS_PATHS = ['/assets/:componentId/:tab/:subTab?', '/groups/:groupId/:componentId/:tab/:subTab?'];
const HIDE_BREADCRUMB_TABS = ['Cryptography', 'Credentials'];

function NRBreadcrumbs() {
  const classes = useStyles();
  const { pathname } = useLocation();
  const matchedPattern = SHOW_ACTIONS_PATHS.find(pattern => matchPath(pattern, pathname));
  const { value: isRiseAiConversationalGptEnabled } = useFlag('rise-ai-conversational-gpt', false);
  const { orgLevelSettings } = useContext(OrgLevelSettingsContext);
  const riseAiConversationalGptEnabled = orgLevelSettings?.riseAiConversationalGptEnabled ?? false;
  let breadcrumbs = useMatches()
    .filter(m => m.handle?.breadcrumb)
    .map(m => ({
      match: m,
      breadcrumb: typeof m.handle.breadcrumb === 'function' ? React.createElement(m.handle.breadcrumb, { params: m.params }) : m.handle.breadcrumb
    }));

  return (
    <div className={classes.breadcrumbContainer}>
      <Box className={classes.root}>
        <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
          {breadcrumbs.map(({ match, breadcrumb }, idx, arr) => {
            const { pathname, params } = match;
            const isLast = idx === arr.length - 1;

            // hide certain tabs if needed
            if (HIDE_BREADCRUMB_TABS.includes(params.tab) && !params.subTab) return null;

            return (
              <React.Fragment key={pathname}>
                {/** first child crumb as H2 */}
                {idx === 0 && (
                  <Typography variant="h2" component="div">
                    {!isLast ? (
                      <NavLink to={pathname} className={classes.link}>
                        {breadcrumb}
                      </NavLink>
                    ) : (
                      breadcrumb
                    )}
                  </Typography>
                )}

                {/** deeper crumbs as body2 with separator */}
                {idx > 0 && (
                  <Typography variant="body2" component="div" sx={{ display: 'flex', alignItems: 'baseline' }}>
                    <span className={classes.separator}>/</span>
                    {!isLast ? (
                      groupIdRegex.test(pathname) ? (
                        breadcrumb
                      ) : (
                        <NavLink to={pathname} className={classes.link}>
                          {breadcrumb}
                        </NavLink>
                      )
                    ) : (
                      breadcrumb
                    )}
                  </Typography>
                )}
              </React.Fragment>
            );
          })}
        </Box>

        {/** Optional status action */}
        <Box sx={{ minWidth: 'fit-content', ml: 2 }}>{SHOW_ACTIONS_PATHS.includes(matchedPattern) && <NRShowAssetStatus />}</Box>
      </Box>

      {/* {SHOW_ACTIONS_PATHS.includes(matchedPattern) && <NRShowOriginalStateSelector />} uncomment when showUnremediated is completed */}
      {SHOW_ACTIONS_PATHS.includes(matchedPattern) && isRiseAiConversationalGptEnabled && riseAiConversationalGptEnabled && <NRRiseAIChatButton />}
      {SHOW_ACTIONS_PATHS.includes(matchedPattern) && <NRViewActivityFeedButton />}
      {SHOW_ACTIONS_PATHS.includes(matchedPattern) && <NRSummaryActions />}
    </div>
  );
}

export default NRBreadcrumbs;
